import { IPlansService } from "../domain/interfaces/IPlansService";
import { ISubscription } from "../presentation/interfaces/ISubscription";

export const GetSubscriptionUseCase = async (service: IPlansService, ownerId: string): Promise<ISubscription> => {
    return service.getSubscription(ownerId);
}